export class EnergyProducer {
  constructor(energy_type: number, energy_source: number, is_main: boolean) {
    this.energy_type = energy_type;
    this.energy_source = energy_source;
    this.is_main = is_main;
  }

  energy_type: number;
  energy_source: number;
  other_energy_type: string | null;
  other_energy_source: string | null;
  total_feed_in_power: number | null;
  is_main: boolean;
}
